import { FC } from 'react';
import { Link } from 'react-router-dom';
import { ThemeProvider, useTheme } from 'styled-components';
import { darkColors, StyledButton } from '@tryhackme/thm-ui-components';
import crownImage from 'src/images/pngs/campaigns/beat-the-price-hike/crown.png';
import { useTrackEventMutation } from 'src/common/slices';
import { Countdown } from '../../components/countdown';
import { useCampaignCta } from '../beat-the-price-hike.hooks';
import { useActiveCampaign } from '../../hooks/use-active-campaign';
import { BeatTheHikePriceTopBarProps } from './beat-the-price-hike-top-bar.types';
import { StyledBar, StyledText, StyledWrapRow, StyledImage, ButtonWrapper } from './beat-the-price-hike-top-bar.styles';
export const BeatTheHikePriceTopBar: FC<BeatTheHikePriceTopBarProps> = ({
  thin
}) => {
  const theme = useTheme();
  const [trackEvent] = useTrackEventMutation();
  const {
    campaign
  } = useActiveCampaign();
  const [ctaText, urlToNavigate] = useCampaignCta(campaign);
  const onCtaClick = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    trackEvent({
      event: 'click-subscribe-now',
      properties: {
        'clicked-on': 'top-banner'
      }
    });
  };
  if (!campaign) return null;
  return <ThemeProvider theme={{
    ...theme,
    colors: darkColors
  }} data-sentry-element="ThemeProvider" data-sentry-component="BeatTheHikePriceTopBar" data-sentry-source-file="beat-the-price-hike-top-bar.tsx">
      <StyledBar $thin={!!thin} data-testid="campaign-bar" data-sentry-element="StyledBar" data-sentry-source-file="beat-the-price-hike-top-bar.tsx">
        <StyledWrapRow data-sentry-element="StyledWrapRow" data-sentry-source-file="beat-the-price-hike-top-bar.tsx">
          <StyledText data-testid="campaign-top-bar-text" data-sentry-element="StyledText" data-sentry-source-file="beat-the-price-hike-top-bar.tsx">
            SAVE BIG BEFORE PRICES GO UP! <span>{campaign.amount}% off</span> annual subscriptions
          </StyledText>
        </StyledWrapRow>
        <StyledWrapRow data-sentry-element="StyledWrapRow" data-sentry-source-file="beat-the-price-hike-top-bar.tsx">
          {!thin && <ButtonWrapper>
              <StyledImage src={crownImage} />
              <StyledButton as={Link} to={urlToNavigate} variant="solid" color="primary" onClick={onCtaClick}>
                {ctaText}
              </StyledButton>
            </ButtonWrapper>}
          <Countdown includeDays vertical dark startTime={campaign.startTime} endTime={campaign.endTime} data-sentry-element="Countdown" data-sentry-source-file="beat-the-price-hike-top-bar.tsx" />
        </StyledWrapRow>
      </StyledBar>
    </ThemeProvider>;
};